import apiClient from "../../utilities/apiService";

export const fetchWaitingList = async (page, size, status) => {
  try {
    const response = await apiClient.get(`${process.env.REACT_APP_BACKEND_URL}/admin/waitingList/list`, 
      {
      params: { page, size, status }, // Automatically appends ?page=0&size=10
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching waiting list:', error);
    throw error;
  }
};

export const updateUserApproveStatus = async (id) => {
  try {
    const response = await apiClient.post(`${process.env.REACT_APP_BACKEND_URL}/admin/waitingList/approve/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Reject API Call
export const updateUserRejectStatus = async (id) => {
  try {
    const response = await apiClient.post(`${process.env.REACT_APP_BACKEND_URL}/admin/waitingList/reject/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteUserFromWaitingList = async (id) => {
  try {
    const response = await apiClient.delete(
      `${process.env.REACT_APP_BACKEND_URL}/admin/waitingList/delete/${id}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export  const saveUserStatusChanges = async (changes) => {
  try {
    const response = await apiClient.post(`${process.env.REACT_APP_BACKEND_URL}/admin/waitingList/bulkUpdate`, changes);
    return response.data;
  } catch (error) { 
    throw error;
  }
}